import './index.scss';
import React from 'react';
import PricingCard from './PricingCard';

const PricingPlans = () => {
  return (
    <div className="pricingplans">
      <div className="container">
        <h2>Flexible Pläne für jede Unternehmensgröße</h2>
        <div className="pricingplans__grid">
          <PricingCard
            name="Starter"
            subtitle="für einfache Websites"
            price="290€"
            features={[
              'Bis zu 200 Website-Seiten',
              'Bis zu 5 PDF-Dokumente',
              'Website-Scraping für 1 Domain',
              '1.000 Chat-Sessions/Monat',
              'Einbettbarer Chatbot',
              'Basis-Anpassung (Farben, Logo)',
              'Standard-Analytics Dashboard',
              'DSGVO & WCAG-konform',
              'E-Mail Support (48h Reaktionszeit)',
            ]}
          />
          <PricingCard
            name="Professional"
            subtitle="für Websites mit erweiterten Anforderungen"
            price="690€"
            features={[
              'Bis zu 500 Website-Seiten',
              'Bis zu 50 PDF-Dokumente',
              'Website-Scraping für 3 Domains',
              '5.000 Chat-Sessions/Monat',
              'Alles aus "Starter"',
              'Erweiterte Analytics',
              'Monatliche automatische Reports',
              'KI-gestützte Log-Analyse',
              'Anpassbare Prompts und Tonalität',
            ]}
          />
          <PricingCard
            name="Enterprise"
            subtitle="für Websites mit komplexen Anforderungen"
            price="1450€"
            features={[
              'Bis zu 2000 Website-Seiten',
              'Bis zu 150 PDF-Dokumente',
              'Website-Scraping für individuelle Domains',
              '10.000 Chat-Sessions/Monat',
              'Dokument-Uploads + API-Datenquellen',
              'Basis-Anpassung (Farben, Logo)',
              'Standard-Analytics Dashboard',
              'DSGVO & WCAG-konform',
              'E-Mail Support (48h Reaktionszeit)',
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default PricingPlans;
